import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { FilterToggleChip } from './filter-toggle';
import { useFilter } from '../filter-context';

interface FilterPriceChipProps {
    onPriceClick: () => void;
    active: boolean;
}

export const FilterPriceChip = (props: FilterPriceChipProps): ReactElement => {
    const { onPriceClick, active } = props;
    const { filter } = useFilter();

    const minPrice = filter.get(FilterParams.MinPrice) ?? undefined;
    const maxPrice = filter.get(FilterParams.MaxPrice) ?? undefined;

    return (
        <FilterToggleChip
            label={<FormattedMessage id="app.filter.price.label" />}
            isSelected={!!minPrice || !!maxPrice}
            onClick={onPriceClick}
            color="dark"
            variant="outlined"
            outlined={true}
            active={active}
        />
    );
};
